import { useState, useMemo, useRef, useEffect, useLayoutEffect } from 'react';
import { createPortal } from 'react-dom';

import { MenuContainer, Container, Header, List, ListContainer, ListItem, ArrowDown } from './custom-select.styled';

export const CustomSelect = (props) => {
  const { items, value, onChange, style, className = '', ...rest } = props;

  /**
   * selected option (вычисляется из items и value, чтобы реагировать на их изменение)
   */
  const selectedOption = useMemo(() => {
    const v = (items || []).filter((el) => el.value === value);
    return v.length ? v[0] : null;
  }, [items, value]);

  const [open, setOpen] = useState(false);

  /**
   * toggler open
   * @returns `
   */
  const toggle = () => {
    if (props.disabled) {
      return;
    }
    setOpen(!open);
  };

  /**
   * select option
   * @param {*} value
   * @returns
   */
  const onOptionClicked = (value) => () => {
    setOpen(false);
    onChange(value);
    //console.log("🚀 ~ onOptionClicked ~ selectedOption", selectedOption);
  };

  /**
   * список рисуется в портале с position: fixed, чтобы не вызывать скролл в родительских контейнерах
   */
  const ref = useRef(null);
  const menuRef = useRef(null);
  const [pos, setPos] = useState(null);

  // если список не помещается снизу — показываем над инпутом
  useLayoutEffect(() => {
    if (!pos || pos.flipped || !menuRef.current) {
      return;
    }
    const h = menuRef.current.offsetHeight;
    const ul = menuRef.current.querySelector('ul');
    const gap = ul ? parseFloat(window.getComputedStyle(ul).marginTop) || 0 : 0;
    const spaceBelow = window.innerHeight - pos.top;
    if (h > spaceBelow && pos.headTop > spaceBelow) {
      setPos({ ...pos, top: Math.max(0, pos.headTop - h), flipped: true, gap });
    }
  }, [pos]);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const rect = ref.current.getBoundingClientRect();
    setPos({ top: rect.bottom, left: rect.left, width: rect.width, headTop: rect.top, flipped: false });

    const close = () => setOpen(false);
    // close on click outside
    const onMouseDown = (e) => {
      if (ref.current?.contains(e.target) || menuRef.current?.contains(e.target)) {
        return;
      }
      close();
    };
    document.addEventListener('mousedown', onMouseDown);
    window.addEventListener('scroll', close, true);
    window.addEventListener('resize', close);
    return () => {
      setPos(null);
      document.removeEventListener('mousedown', onMouseDown);
      window.removeEventListener('scroll', close, true);
      window.removeEventListener('resize', close);
    };
  }, [open]);

  // class name
  const cl = `${selectedOption?.value} ${className}`;

  return (
    <div ref={ref} style={style}>
      <Container {...rest}>
        <Header onClick={toggle} className={cl}>
          {selectedOption?.name || ''}
        </Header>
        {open &&
          pos &&
          createPortal(
            <ListContainer
              ref={menuRef}
              style={{ position: 'fixed', top: pos.top, left: pos.left, width: pos.width, minWidth: 0, maxWidth: pos.width, zIndex: 10000 }}
            >
              <MenuContainer className={className} $gap={pos.flipped ? pos.gap : undefined}>
                <List>
                  {(items || []).map((option) => {
                    let cl = option.value === selectedOption?.value ? 'active' : '';
                    cl += ' ' + option.value;
                    return (
                      <ListItem className={cl} onClick={onOptionClicked(option.value)} key={option.value}>
                        {option.name}
                      </ListItem>
                    );
                  })}
                </List>
              </MenuContainer>
            </ListContainer>,
            document.body,
          )}
        {!props.disabled && <ArrowDown active={open} />}
      </Container>
    </div>
  );
};
